import {cachedValueCreate} from "@wix/devzai-utils-common";

class MediaFeaturesDetectorSingleton {

    private cachedSupportsHover = cachedValueCreate(() => {
        return window.matchMedia('(hover: hover)').matches && window.matchMedia('(pointer: fine)').matches;
    })
    public get supportsHover () { return this.cachedSupportsHover.getValue() }

    private cachedSupportsEyeDropper = cachedValueCreate(() => {
        return 'EyeDropper' in window;
    });
    public get supportsEyeDropper () { return this.cachedSupportsEyeDropper.getValue() }

    private cachedIsTouchDevice = cachedValueCreate(() => {
        return ('ontouchstart' in window || navigator.maxTouchPoints > 0);
    })
    public get isTouchDevice () { return this.cachedIsTouchDevice.getValue() }

    private cachedElementMoveBeforeSupported = cachedValueCreate(() => {
        return typeof (Element.prototype as any).moveBefore === 'function';
    })

    public get elementMoveBeforeSupported () { return this.cachedElementMoveBeforeSupported.getValue() }
}

export const MediaFeaturesDetector = new MediaFeaturesDetectorSingleton();